import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import Prompt from '../../widgets/Prompt';
import SkillsProgramSetupSearch from '../program/SkillsProgramSetupSearch';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import AssessorInterventionAudit from '../assessor/AssessorInterventionAudit';
import FormDialog from "../FormDialog";
import { OutComeStatusForm } from "../common/OutcomeStatusForm";
import { AssessmentEndDateForm } from "../common/AssessmentEndDateForm";
import Dialog from '@material-ui/core/Dialog';
import { Typography } from "antd";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';


export const skillsProgrammeHeadCells = [
    { id: 'SkillsProgrammeCode', numeric: false, disablePadding: true, label: 'Skills Programme ID' },
    { id: 'SkillsProgrammeTitle', numeric: false, disablePadding: true, label: 'Skills Programme Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'RegistrationStartDate', numeric: false, disablePadding: true, label: 'Registration Start Date' },
    { id: 'RegistrationEndDate', numeric: false, disablePadding: true, label: 'Registration End Date' },
    { id: 'AssessorAssessmentEndDate', numeric: false, disablePadding: true, label: 'Assessor Assessment End Date' },
    { id: 'Outcome', numeric: false, disablePadding: true, label: 'Outcome' },
    { id: 'Status', numeric: false, disablePadding: true, label: 'Status' }
];
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const QUSheadCells = [
    { id: 'SAQAUnitStandardID', numeric: false, disablePadding: true, label: 'SAQA Unit Standard ID' },
    { id: 'MQAUnitStandardID', numeric: false, disablePadding: true, label: 'MQA Unit Standard ID' },
    { id: 'SAQAUnitStandardTitle', numeric: false, disablePadding: true, label: 'SAQA Unit Standard Title' },
    { id: 'Credits', numeric: false, disablePadding: true, label: 'Credits' },
    { id: 'UnitStandardType', numeric: false, disablePadding: true, label: 'Unit Standard Type' }
];


const useStyles = theme => ({
    appBar: {
        position: 'relative',
    },
    title: {
        flex: 1,
        color: 'white',
    },
    table: {
        minWidth: 700,
    },
});

const toolbarRef = React.createRef();
const addFormRef = React.createRef();
const updateFormRef = React.createRef();

const utils = new ViewUtils();

class AssessorSkillsProgrammeSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                SkillsProgrammeCode: "",
                SkillsProgrammeTitle: "",
                AssessorID: this.props.location.state.AssessorID
            },
            showTable: true,
            linkDialogOpen: false,
            updateDialogOpen: false,
            updateDateDialogOpen: false,
            formDialogOpen: false,
            updateDateformDialogOpen: false,
            auditDialogOpen: false,
            selectedSkillsProgramme: null,
            propmtOpen: false,
            promptTitle: "Unlink Skills Programme From Assessor",
            promptContent: "Are you sure you want to unlink this skills programme from the assessor?",
            message: "",
            messageStyle: "",
            searchParameters: [{ Name: "AssessorID", Value: this.props.location.state.AssessorID }],
            searchParameters2: [{ Name: "Id", Value: 0 }],
            OpenDialog: false,
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'link', label: '', tooltip: 'Link Skills Programme/s to the assessor', icon: 'LinkIcon' },
                        { id: 'update', label: '', tooltip: 'Update the status and outcome of the selected skills programme', disabled: utils.isNull(this.state.selectedSkillsProgramme), icon: 'UpdateIcon' },
                        { id: 'audit', label: '', tooltip: 'View Record Audit Trail', disabled: utils.isNull(this.state.selectedSkillsProgramme) , icon: 'AuditIcon' },
                        { id: 'unlink', label: '', tooltip: 'Un-link selected skills programme from the assessor', disabled: utils.isNull(this.state.selectedSkillsProgramme), icon: 'LinkOffIcon' },
                        { id: 'updateDate', label: 'Update Assessor Assessment End Date', tooltip: 'Update the Assessor Assessment End Date', disabled: utils.isNull(this.state.selectedSkillsProgramme) },
                        { id: 'view', label: '', tooltip: 'View Unit Standards', icon: 'ViewIcon', disabled: utils.isNull(this.state.selectedSkillsProgramme) },
                    ]
                }
            ]
        };

    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/assessor',
                state: { selection: this.props.location.state.AssessorID }
            });
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, message: "" })
        }
        else if ("update" === buttonId) {
            this.setState({ updateDialogOpen: true, message: "" })
        }
        else if ("audit" === buttonId) {
            this.setState({ auditDialogOpen: true, message: "" })
        }
        else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
        else if ("updateDate" === buttonId) {
            this.setState({ updateDateDialogOpen: true, message: "" })
        }
        else if ("view" === buttonId) {
            this.setState({ OpenDialog: true, message: "" })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedSkillsProgramme: null,
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            });
            //Force a refresh
            this.setState({ searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)) })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    unlinkUnitstandard(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedSkillsProgramme}&assessorId=${this.props.location.state.AssessorID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, null);
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedSkillsProgramme: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            let newsearchParameters2 = [...this.state.searchParameters2];
            let temp_element = { ...newsearchParameters2[0] };
            temp_element.Value = selection[0].Id
            newsearchParameters2[0] = temp_element;
    
            this.setState({
                searchParameters2: JSON.parse(JSON.stringify(newsearchParameters2)),
                selectedSkillsProgramme: selection[0].Id,
                message: "",
                messageStyle: ""
            });
            
        }
        else {
            this.setState({
                searchParameters2: [{ Name: "Id", Value: 0 }],
                selectedSkillsProgramme: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("audit", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("update", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("updateDate", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
        toolbarRef.current.setButtonDisabled("view", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    dialogActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                updateDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, auditDialogOpen: false, linkDialogOpen: false, selection: this.props.location.state.selection, selectedSkillsProgramme: null
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                updateDialogOpen: false,
                updateDateDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    dialogUpdateActionHandler(isCancel, added) {
        if (added === true) {
            this.setState({
                showTable: false,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                updateDialogOpen: false, updateDateDialogOpen: false, selectedSiteVisit: null, auditDialogOpen: false, linkDialogOpen: false, selection: this.props.location.state.selection, selectedSkillsProgramme: null
            }, () => {
                this.setState({ showTable: true })
            });
        }
        else if (isCancel === true) {
            this.setState({
                updateDialogOpen: false,
                updateDateDialogOpen: false,
                linkDialogOpen: false,
                auditDialogOpen: false
            })
        }
    }

    CloseForm = () => {
        this.setState({
            OpenDialog: false,
            selectedId: null,
            clearSelectedRow: true,
            selectedSkillsProgramme: null
        });
        toolbarRef.current.setButtonDisabled("audit", true);
        toolbarRef.current.setButtonDisabled("update", true);
        toolbarRef.current.setButtonDisabled("unlink", true);
        toolbarRef.current.setButtonDisabled("updateDate", true);
        toolbarRef.current.setButtonDisabled("view", true);
    };

    render() {
        const { classes } = this.props;
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {"Assessor > Skills Programmes" + (this.props.location.state !== null ? " > " + this.props.location.state.AssessorName + " - " + this.props.location.state.AssessorIDNo : "> Add")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <div className="searchResults">
                    <EnhancedToolbar
                        highlight={false}
                        ref={toolbarRef}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />

                    {this.state.showTable === true && (
                        <EnhancedTable
                            headCells={skillsProgrammeHeadCells}
                            dataUrl={`api/sims/assessorskillsprogramme/GetAssessorSkillsProgrammes`}
                            height="50vh"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>

                <FormDialog
                    open={this.state.updateDialogOpen}
                    dialogTitle={"Update Outcome and Status"}
                    viewRef={this}
                    entityId={this.state.selectedUnitStandard}
                    formRef={addFormRef}
                    usePut={true}
                    saveUrl={"api/sims/assessorskillsprogramme/UpdateSkillsProgrammeOutcomeStatus"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                >
                    <OutComeStatusForm ref={addFormRef} id={this.state.selectedSkillsProgramme} dataURL='api/sims/assessorskillsprogramme/GetFindSkillsProgrammeOutcomeStatus' controllerName='assessorskillsprogramme' />
                </FormDialog>

                <FormDialog
                    open={this.state.updateDateDialogOpen}
                    dialogTitle={"Update Assessor Assessment End Date"}
                    viewRef={this}
                    entityId={this.state.selectedUnitStandard}
                    formRef={updateFormRef}
                    usePut={true}
                    saveUrl={"api/sims/assessorskillsprogramme/UpdateSkillsProgrammeAssessmentEndDate"}
                    closeHandler={(isCancelled, linked) => this.dialogUpdateActionHandler(isCancelled, linked)}
                >
                    <AssessmentEndDateForm ref={updateFormRef} id={this.state.selectedSkillsProgramme} dataURL='api/sims/assessorskillsprogramme/GetFindSkillsProgrammeAssessmentEndDate' controllerName='assessorskillsprogramme' />
                </FormDialog>

                <LinkDialog open={this.state.auditDialogOpen}
                    title={"Audit Trail"}
                    closeHandler={(isCancelled, linked) => this.dialogActionHandler(isCancelled, linked)}
                    dialogTitle={"Audit Trail"}
                    selectionId={this.props.location.state.selectedQualification}
                >

                    <AssessorInterventionAudit dataUrl={"api/sims/assessorskillsprogramme/GetAssessorSkillsProgrammeAudit"}
                        multiSelect={false} showTitle={false}
                        Id={this.state.selectedSkillsProgramme}
                    />
                </LinkDialog>


                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.AssessorName}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Skills Programme to Assessor: ${this.props.location.state.AssessorName}`}
                    linkName={"SkillsProgrammes"} postUrl={"api/sims/assessorskillsprogramme/LinkAssessorSkillsProgramme"} usePost={true}
                    selectionId={this.props.location.state.AssessorID}
                >
                    <SkillsProgramSetupSearch
                        dataUrl={"api/sims/assessorskillsprogramme/GetSearchLinkableSkillsProgrammes"}
                        multiSelect={true} showTitle={false} customMessage={"No Skills Programmes with this search criteria have been found."}
                        programmeId={this.props.location.state.AssessorID} programmeType="Q"
                        mode="lookup" allowClear={true}
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkUnitstandard(`api/sims/assessorskillsprogramme/RemoveAssessorSkillsProgramme`)}
                    closePrompt={this.closePrompt}
                />

                <Dialog fullScreen open={this.state.OpenDialog} onClose={this.CloseForm} TransitionComponent={Transition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={this.CloseForm} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h1" className={classes.title}>
                                {"Skills Programme Unit Standards"}
                            </Typography>

                        </Toolbar >
                    </AppBar >
                    <br /><br />
                    <EnhancedTable
                        headCells={QUSheadCells}
                        dataUrl={"api/sims/assessorskillsprogramme/GetAssessorSPUS"}
                        makeRowBold={true}
                        searchParameters={this.state.searchParameters2} paged={false} autoFetchData={true} />
                </Dialog >
            </ViewContainer>
        );
    }
}

export default withRouter(withStyles(useStyles())(connect()(AssessorSkillsProgrammeSearch)));
